"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Edges = function Edges(props) {
  return /*#__PURE__*/_react.default.createElement(Container, props, props.children);
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  padding: 0 2.5%;\n  margin: 0 auto;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.size === "xs" && "max-width: 460px;";
}, function (props) {
  return props.size === "sm" && "max-width: 600px;";
}, function (props) {
  return props.size === "md" && "max-width: 1024px;";
}, function (props) {
  return props.size === "lg" && "max-width: 1280px;";
}, function (props) {
  return props.size === "xl" && "max-width: 1440px;";
});

var _default = Edges;
exports.default = _default;